import { Chip } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import EventIcon from '@mui/icons-material/Event';
import { Link } from 'react-router-dom';

/**
 * Ссылки-«чипы» между сущностями (02_ADMIN_ARCHITECTURE.md §4.3).
 * Рисуются из уже загруженных данных, без дополнительных запросов.
 */

interface EntityLinkProps {
  id: string;
  label?: string | null;
}

export function UserLink({ id, label }: EntityLinkProps): JSX.Element {
  return (
    <Chip
      component={Link}
      to={`/users/${id}/show`}
      onClick={(e) => e.stopPropagation()}
      icon={<PersonIcon />}
      label={label ?? id.slice(0, 8)}
      size="small"
      clickable
      variant="outlined"
      color="primary"
    />
  );
}

export function InvitationLink({ id, label }: EntityLinkProps): JSX.Element {
  return (
    <Chip
      component={Link}
      to={`/invitations/${id}/show`}
      onClick={(e) => e.stopPropagation()}
      icon={<EventIcon />}
      label={label ?? id.slice(0, 8)}
      size="small"
      clickable
      variant="outlined"
      color="secondary"
    />
  );
}

export function ReportLink({ id, label }: EntityLinkProps): JSX.Element {
  return (
    <Chip
      component={Link}
      to={`/reports/${id}/show`}
      onClick={(e) => e.stopPropagation()}
      label={label ?? `Жалоба ${id.slice(0, 8)}`}
      size="small"
      clickable
      variant="outlined"
      color="warning"
    />
  );
}
